// products with the following crop names aren't available to view its details
// these crop names should be hidden from the Buyer's navigation menu
// https://yalantis.atlassian.net/browse/SPZ-1961
export const RESTRICTED_CROPS = ['product'];
